<template>
    <section class="slice slice-cookie-purpose">
        <h2>{{ slice.primary.title }}</h2>
    </section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {CookiePurposeSlice} from '@prismicio-types';

    const {slice} = defineProps(getSliceComponentProps<CookiePurposeSlice>(['slice', 'index', 'slices', 'context']));
</script>
